import axios from '_u/axios'

// @compatibility 补齐时分秒
function fillHms(dateStr) {
    if (dateStr) {
        var count = dateStr.length - dateStr.replace(/:/g, '').length

        if (count == 0) return dateStr + ' 00:00:00'
        if (count == 1) return dateStr + ':00'
    }

    return dateStr
}

// 账单列表
export const billList = (body) => {
    return axios.post('api/bill/info/list', body).then((res) => {
        var list = res.data.page.list

        if (list) {
            list.forEach((v) => (v.realDate = fillHms(v.realDate)))
        }

        return res
    })
}

// 账单详情
export const billView = (id) => {
    return axios.post('api/bill/info/view', { id }).then((res) => {
        var entity = res.data.entity

        if (entity) {
            entity.realDate = fillHms(entity.realDate)
        }

        return res
    })
}

// 账单新增
export const billAdd = (body) => {
    return axios.post('api/bill/info/add', body)
}

// 账单修改
export const billUpdate = (body) => {
    return axios.post('api/bill/info/update', body)
}

// 根据房间获取账期
export const billPeriods = (houseId) => {
    return axios.post('api/bill/info/periods', { houseId })
}

// 根据合同编号获取账期
export const queryPeriods = (contractId) => {
    return axios.post('api/bill/info/queryPeriods', { contractId })
}

// 账单作废
export const billInvalid = (id) => {
    return axios.post('api/bill/info/invalid', { id })
}

// 未到账
export const billNotReceived = (id) => {
    return axios.post('api/bill/info/notReceive', { id })
}

// 账单作废-批量
export const billBatchInvalid = (ids) => {
    return axios.post('api/bill/info/batchInvalid', { ids })
}

// 账单收付款
export const billPayment = (body) => {
    return axios.post('api/assembly/bill/info/payment', body)
}

// 账单收付款-批量
export const billBatchPayment = (body) => {
    return axios.post('api/assembly/bill/info/batchPayment', body)
}

// 地址迁移
export const billAddrMigrate = (body) => {
    return axios.post('api/bill/info/migrate', body)
}

// 账单查看收据
export const receiptQueryByBillView = (billId) => {
    return axios.post('api/finance/receipt/queryByBill', { billId })
}

//
export const billRecordList = (body) => {
    return axios.post('api/bill/updatelog/list', body)
}

// 查询自定义的账期列表
export const queryDefinedPeriods = (body) => {
    return axios.post('api/bill/info/queryDefinedPeriods', body)
}
